import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {AgentFormValues} from '../shared/novaAgentForm';

export interface CreateAgentModalPayload {
	mode: 'create' | 'edit';
	categories: Array<{categoryId: string; name: string}>;
	existingNames: string[];
	initialValues?: AgentFormValues;
	onSubmit: (values: AgentFormValues) => Promise<void>;
	onCreateCategory: (name: string) => Promise<{categoryId: string; name: string}>;
}

export const showCreateAgentModal = (props: CreateAgentModalPayload): void => {
	showModal({type: MODAL_TYPE.NOVA_CREATE_AGENT, ...props});
};

// Edit is the same modal in 'edit' mode, seeded with the agent's current values. The name is a
// mutable label and stays editable in this mode too — only identity (the Relay global id) is
// never rendered/editable, and it is distinct from the name (see CreateAgentModal.tsx).
export type EditAgentModalPayload = Omit<CreateAgentModalPayload, 'mode' | 'initialValues'> & {
	initialValues: AgentFormValues;
};

export const showEditAgentModal = (props: EditAgentModalPayload): void => {
	showCreateAgentModal({...props, mode: 'edit'});
};
